'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { DashboardFloatingAlertStore } from 'dashboard-components/js/shared/DashboardFloatingAlertStore.ts';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const notifyUnsubscribeSuccess = (recipientEmail, emailSubject) => {
  DashboardFloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `emailUnsubscribe.alert.success.title`,
      options: {
        email: recipientEmail
      }
    }),
    message: /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `emailUnsubscribe.alert.success.message`,
        options: {
          emailSubject
        }
      })
    }),
    type: 'success'
  });
};
export const notifyUnsubscribeFailure = (recipientEmail, emailSubject) => {
  DashboardFloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `emailUnsubscribe.alert.failure.title`,
      options: {
        email: recipientEmail,
        emailSubject
      }
    }),
    message: /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `emailUnsubscribe.alert.failure.message`
      })
    }),
    type: 'danger'
  });
};
export const notifyWrongUnsubscribeLink = (recipientEmail, emailSubject) => {
  DashboardFloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `emailUnsubscribe.alert.wrongLink.title`,
      options: {
        email: recipientEmail,
        emailSubject
      }
    }),
    message: /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `emailUnsubscribe.alert.wrongLink.message`
      })
    }),
    type: 'info',
    sticky: true
  });
};